export default __webpack_public_path__ + "static/media/plus-solid.c82024f4.svg";